import React, { useState, useEffect } from 'react'
import './Profile.css'
import Spinner from '../../utilities/spinner/Spinner'

//Bootstrap
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

//Redux
import { useSelector, useDispatch } from 'react-redux'
import { updateUser } from '../../redux'

function EditProfileForm() {
  const [isEditing, setIsEditing] = useState(false)
  const [state, setState] = useState(null)
  const [validator, setValidator] = useState({
    isNameFilled: true,
    isPhoneFilled: true,
  })

  const ui = useSelector((state) => state.ui)
  const user = useSelector((state) => state.user)

  const dispatch = useDispatch()

  const populateUserProfile = () => {
    setState({
      name: user.credentials.name,
      title: user.credentials.title,
      hpNumber: user.credentials.hpNumber,
      position: user.credentials.position,
      location: user.credentials.location,
    })
  }

  useEffect(() => {
    populateUserProfile()
  }, [])

  const handleSave = () => {
    if (checkAllFields()) {
      dispatch(updateUser(state, user.credentials.id, turnOffEdit))
    }
  }

  const turnOffEdit = (repopulate = true) => {
    setIsEditing(false)
    setValidator({
      isNameFilled: true,
      isPhoneFilled: true,
    })
    if (repopulate) populateUserProfile()
  }

  const handleOnChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const checkAllFields = () => {
    const isNameFilled = state.name.length > 0
    const isPhoneFilled = state.hpNumber.length > 0
    setValidator({
      ...validator,
      isNameFilled,
      isPhoneFilled,
    })
    return isNameFilled && isPhoneFilled
  }

  let editProfileFormMarkup = state ? (
    <>
      <Form>
        <Form.Group controlId='formName'>
          <Form.Label>Name</Form.Label>
          <Form.Control readOnly={!isEditing} required type='text' name='name' onChange={handleOnChange} value={state.name} />
          {validator.isNameFilled ? null : <span className='error-text'>Please fill in your name</span>}
        </Form.Group>

        <Form.Group controlId='formTitle'>
          <Form.Label>Title</Form.Label>
          <Form.Control readOnly={!isEditing} type='text' name='title' onChange={handleOnChange} value={state.title} />
        </Form.Group>

        <Form.Group controlId='formEmail'>
          <Form.Label>Email</Form.Label>
          <Form.Control readOnly defaultValue={user.credentials.email} />
        </Form.Group>

        <Form.Group controlId='formPhone'>
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            readOnly={!isEditing}
            required
            type='text'
            name='hpNumber'
            onChange={handleOnChange}
            value={state.hpNumber}
          />
          {validator.isPhoneFilled ? null : <span className='error-text'>Please fill in your phone number</span>}
        </Form.Group>

        <Form.Group controlId='formPosition'>
          <Form.Label>Position</Form.Label>
          <Form.Control readOnly={!isEditing} type='text' name='position' onChange={handleOnChange} value={state.position} />
        </Form.Group>

        <Form.Group controlId='formLocation'>
          <Form.Label>Location</Form.Label>
          <Form.Control readOnly={!isEditing} type='text' name='location' onChange={handleOnChange} value={state.location} />
        </Form.Group>
      </Form>
      {isEditing ? (
        <div className='edit-button-style'>
          <Button variant='success' onClick={handleSave} disabled={ui.loading}>
            Save
          </Button>
          <Button variant='danger' onClick={turnOffEdit} disabled={ui.loading}>
            Cancel
          </Button>
        </div>
      ) : (
        <Button variant='primary' onClick={() => setIsEditing(true)} className='edit-button-style'>
          Edit Profile
        </Button>
      )}
    </>
  ) : (
    <Spinner />
  )

  return editProfileFormMarkup
}

export default EditProfileForm
